import { Decoder, object, string, array, number, boolean } from '@mojotech/json-type-validation';
import { ILogger } from '@cian/logger/shared';
import { INewbuildingLabel } from '../../types/newbuildingLabel';

/** Валидирует json с настройками плашек для новостроек  */
// tslint:disable-next-line:no-any
export const isRSNewbuildingLabel = (value: any, logger: ILogger): boolean => {
  const newbuildingLabelDecoder: Decoder<INewbuildingLabel> = object({
    isEnabled: boolean(),
    onlineDeal: array(
      object({
        regionId: number(),
        newBuildingIds: array(number()),
      }),
    ),
    indicatorTexts: object({
      onlineDeal: string(),
      consultantOnline: string(),
      builderOnline: string(),
    }),
    infoTexts: object({
      onlineDeal: object({
        title: string(),
        text: string(),
      }),
      consultantOnline: object({
        title: string(),
        text: string(),
      }),
      builderOnline: object({
        title: string(),
        text: string(),
      }),
    }),
  });
  const result = newbuildingLabelDecoder.run(value);
  const isValid = result.ok;

  if (!isValid) {
    logger.error('Невалидное значение runtime переменной newbuildingLabels');
  }

  return isValid;
};
